import React, { useState } from "react";
import Accordion, { AccordionItem } from "@ingka/accordion";

import Button from "@ingka/button";
import InlineMessage from "@ingka/inline-message";
import informationCircle from "@ingka/ssr-icon/paths/information-circle";
import ArrowRightIcon from "@ingka/ssr-icon/paths/arrow-right";
import NamingGuidelinesPopup from "@coworker/apprestructured/src/tasks/components/NamingGuidelinesPopup/NamingGuidelinesPopup";

import styles from "./add-custom-location.module.css";
import trackerHelper from "../../../../helpers/tracker";
import { useTranslation } from "@coworker/locales";

type LocationObject = {
  locationCode: string;
  locationSection: string;
  locationDepartment: string;
  locationCustom?: string;
};

interface AddCustomLocatioProps {
  submitWithConfirmation: (locationObject: LocationObject) => void;
  query: string;
}

const AddCustomLocation = ({
  submitWithConfirmation,
  query,
}: AddCustomLocatioProps) => {
  const { t } = useTranslation();

  const [isNamingConventionsOpen, setIsNamingConventionsOpen] = useState(false);
  const [accordionState, setAccordionState] = useState(false);

  return (
    <div className={styles["add-custom-location"]}>
      <div className={styles["section"]}>
        <Button
          iconPosition="trailing"
          ssrIcon={ArrowRightIcon}
          text={t("namingGuideLinesString")}
          type="secondary"
          fluid
          onClick={() => {
            setIsNamingConventionsOpen(true);
            trackerHelper.trackNamingConventionPopupButton();
          }}
        />
        {isNamingConventionsOpen && (
          <NamingGuidelinesPopup
            handleClose={() => {
              setIsNamingConventionsOpen(false);
            }}
          />
        )}
      </div>
      <div className={`${styles["section"]} ${styles["query-preview"]}`}>
        {query}
      </div>
      <Accordion
        style={{ background: "var(--white)" }}
        padded={true}
        id="Custom-location-accordion"
        children={
          <AccordionItem
            key={"custom-location-item-key"}
            id={"custom-location-id"}
            title={t("customLocationInformationString")}
            onHeadingClicked={() => {
              trackerHelper.accordionTracker();
              setAccordionState(!accordionState);
            }}
            open={accordionState}
            children={
              <div className={styles["information-section"]}>
                <InlineMessage
                  title={t("customLocationsString")}
                  body={t("customLocationsMessageString")}
                  variant={"informative"}
                  ssrIcon={informationCircle}
                />
              </div>
            }
          />
        }
      ></Accordion>
      <div className={styles["footer"]}>
        <Button
          text={t("addCustomLocationString")}
          type="primary"
          fluid
          onClick={() => {
            submitWithConfirmation({
              locationCode: query,
              locationSection: "",
              locationDepartment: "",
              locationCustom: query,
            });
            trackerHelper.trackAddCustomLocationButtonClick();
          }}
        />
      </div>
    </div>
  );
};

export default AddCustomLocation;
